import { type Store } from 'redux';

import { type Upload } from '@air/redux-uploader';

import { metadataForPrivateUploadSelector } from '~/store/privateUploadMetadata/selectors';
import { type AirState } from '~/store/types';
import { uploadingPathToBoardIdSelector } from '~/store/uploadingPathToBoardId/selector';
import { getUploadBoardIdUtil } from '~/store/uploadingPathToBoardId/utils';

export const getUploadBoardIdFromStore = ({ upload, store }: { upload: Upload; store: Store<AirState> }) => {
  const pathToBoardId = uploadingPathToBoardIdSelector(store.getState());
  const metadata = metadataForPrivateUploadSelector(store.getState(), upload.id);
  if (metadata) {
    return getUploadBoardIdUtil({
      batchId: upload.batchId,
      uploadMetadata: metadata,
      pathToBoardIdState: pathToBoardId,
    });
  }
};
